import { Box, Button, CircularProgress, FormControl, Grid, IconButton, InputAdornment, MenuItem, Modal, OutlinedInput, Select, Skeleton, Stack, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React from 'react';
import { useNavigate } from 'react-router';
import SearchIcon from '@mui/icons-material/Search';
import { IconPlus } from '@tabler/icons';
import { useState } from 'react';
import CustomNoRowsOverlay from 'ui-component/customNoRowsOverlay';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
// import AddEditInsuranceForm from './AddEditInsuranceForm';
import { useEffect } from 'react';
import { del, get } from '../../axios/apiService';
import LoadingBackdrop from 'ui-component/full-screen-loadder/LoadingBackdrop';
import toast from 'react-hot-toast';
import { Modules } from 'store/constant';
import AddEditContactForm from '../../ui-component/contact/AddEditContactForm';
import MainCard from 'ui-component/cards/MainCard';
import { generateLabel } from 'utils/commonfunction';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4
};

function Contact() {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [rowCount, setRowCount] = useState(0);
  const [options, setOptions] = useState([]);
  const [isShowForm, setIsShowForm] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [cusPage, setCusPage] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10
  });
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [cusOpen, setCusOpen] = useState(false);

  const [sortModel, setSortModel] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleteContactId, setIsDeleteContactId] = useState('');
  const [selectedOption, setSelectedOption] = useState({ id: '', label: '' });
  const [permissionMatrix, setPermissionMatrix] = useState({});


  useEffect(() => {
    const UserPermissions = JSON.parse(localStorage.getItem(`UserPermissions`));
    const permission = UserPermissions?.find((x) => x.moduleId === Modules.WillManagement_Insurance);
    if (permission) {
      setPermissionMatrix(permission);
    } else {
      setPermissionMatrix(null);
    }
  }, []);

  useEffect(() => {
    if (cusOpen && (!options || options?.length === 0)) {
      fetchCustomer();
    }
  }, [cusOpen]);

  useEffect(() => {
    fetchContacts();
  }, [paginationModel, sortModel, search, isShowForm, selectedOption]);

  const fetchContacts = async () => {
    if (selectedOption.id == null || selectedOption.id == undefined) {
      return
    }
    setLoading(true);
    try {
      const sortField = sortModel.length ? sortModel[0].field : "";
      const sortOrder = sortModel.length ? (sortModel[0].sort === "asc" ? "Ascending" : "Descending") : "";
      const sortQuery =
        sortField != ""
          ? `&$orderby=${sortField}&$orderbydirection=${sortOrder}`
          : "&$orderby=CreatedDate&$orderbydirection=Descending";
      const searchQuery =
        search != ""
          ? `&$filter=firstName~LIKE~${search} OR LastName~LIKE~${search} OR MobileNumber~LIKE~${search} OR Alternate_MobileNumber~LIKE~${search} OR Email~LIKE~${search}`
          : "";
      const customerId = `&$customerId=${selectedOption.id}`
      let response = await get(
        `Contact?$skip=${paginationModel.page * paginationModel.pageSize}&$top=${paginationModel.pageSize
        }${searchQuery}${sortQuery}${customerId}`,
        null
      );

      if (response != null) {
        setContacts(response.values);
        setRowCount(response.totalCount);
      }
    } catch (err) {
      console.error(err?.message);
    } finally {
      setLoading(false);
    }
  };
  const handeRedirectAddContact = () => {
    navigate('/contact/add-contact');
  };
  const ActionButtons = (row) => {
    return permissionMatrix && permissionMatrix.writeRights === true ? (
      <Stack direction={'row'} spacing={2}>
        <IconButton
          color="primary"
          size="large"
          onClick={() => {
            console.log('rowData', row);
            // setIsShowForm(true);
            // setIsEditContactId(row.id);
            navigate(`/contact/edit-contact/${row.id}`);
          }}
        >
          <EditIcon />
        </IconButton>
        <IconButton
          color="error"
          size="large"
          onClick={() => {
            setOpen(true);
            setIsDeleteContactId(row.id);
          }}
        >
          <DeleteIcon />
        </IconButton>
      </Stack>
    ) : (
      <></>
    );
  };

  const columns = [
    { field: 'firstName', headerName: 'First Name', flex: 1 },
    { field: 'lastName', headerName: 'Last Name', flex: 1 },
    { field: 'email', headerName: 'Email', flex: 1 },
    { field: 'mobileNumber', headerName: 'MobileNumber', flex: 1 },
    { field: 'alternate_MobileNumber', headerName: 'AlternateMobileNumber', flex: 1 },
    {
      field: 'action',
      headerName: 'Actions',
      renderCell: (params) => <ActionButtons {...params.row} />,
      align: 'right',
      width: 120,
      sortable: false,
      filterable: false
    }
  ];

  const DeleteContact = async () => {
    if (isDeleteContactId == null) {
      setOpen(false);
    }
    setLoading(true);
    try {
      let response = await del(`Contact/${isDeleteContactId}`, null);
      if (!response) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      toast.success('Contact deleted successfully');
      handleClose();
      setPaginationModel({
        page: 0,
        pageSize: 10
      });
    } catch (error) {
      toast.error('Not deleting Contact');
    } finally {
      setLoading(false);
    }
  };



  const handleClose = () => {
    setOpen(false);
  };
  const handleSearchChange = (event) => {
    setSearch(event.target.value);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  };

  const fetchCustomer = async () => {
    if (!hasMore) return; // Prevent fetching if no more data

    setLoading(true);
    try {
      const response = await get(`Customer?page=${cusPage}&pageSize=999999`);
      const customerData = response?.values?.map((x) => {
        // return { id: x.id, label: x.givenName };
        return {
          id: x.id,
          label: generateLabel({
            givenName: x?.givenName || "",
            displayName: x?.displayName || "",
            mobileNumber: x?.mobileNumber || "",
          }),
        };
      });

      if (customerData && customerData.length > 0) {
        setOptions((prevOptions) => [...prevOptions, ...customerData]);

        const totalCount = response.totalCount;
        const hasMoreData = cusPage * 10 < totalCount; // Use pageSize to calculate

        if (hasMoreData) {
          setCusPage(cusPage + 1); // Increment the page number
        } else {
          setHasMore(false); // No more data to fetch
        }
      } else {
        setHasMore(false); // No more data to fetch
      }
    } catch (error) {
      console.error('Error fetching customers:', error.message);
    } finally {
      setLoading(false);
    }
  };
  const handleSortModelChange = (model) => {
    setSortModel(model);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  };

  const handleScroll = (event) => {
    const bottom = event.target.scrollHeight - event.target.scrollTop <= event.target.clientHeight + 1;
    if (bottom && hasMore && !loading) {
      fetchCustomer();
    }
  };

  const handleChangeCustomer = (event) => {
    const selectedId = event.target.value;
    const selectedLabel = options.find((option) => option.id === selectedId)?.label || '';
    setSelectedOption({ id: selectedId, label: selectedLabel });
  };

  return (
    <>
      <MainCard title="My Contact">

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={0}>
              <Select
                size='small'
                sx={{ marginRight: '10px' }}
                open={cusOpen}
                value={selectedOption.id || ''}
                onChange={handleChangeCustomer}
                onOpen={() => setCusOpen(true)}
                onClose={() => setCusOpen(false)}
                MenuProps={{
                  PaperProps: {
                    onScroll: handleScroll,
                    style: {
                      maxHeight: 300,
                      overflowY: 'auto'
                    }
                  }
                }}
                renderValue={(selectedId) => {
                  if (!selectedId) {
                    return 'Select a customer';
                  }
                  const selectedOptionLabel = options.find((option) => option.id === selectedId)?.label || 'Select a customer';
                  return selectedOptionLabel;
                }}
                style={{ width: 200 }}
              >
                {/* {options &&
                        options.map((option, index) => (
                            <MenuItem key={index} value={option.id}>
                                {option.label}
                            </MenuItem>
                        ))}
                    {loading && (
                        <MenuItem disabled>
                            <CircularProgress size={24} />
                        </MenuItem>
                    )} */}
                {loading ? (
                  <MenuItem disabled>
                    {/* Skeleton loader for loading state */}
                    <Skeleton width="100%" height={48} />
                  </MenuItem>
                ) : (
                  options.map((option, index) => (
                    <MenuItem key={index} value={option.id}>
                      {option.label}
                    </MenuItem>
                  ))
                )}
              </Select>
              <form noValidate autoComplete="off" style={{ marginRight: 10 }}>
                <FormControl sx={{ width: '25ch' }} size="small">
                  <OutlinedInput
                    placeholder="Search"
                    value={search}
                    onChange={handleSearchChange}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderColor: 'grey'
                        },
                        '&:hover fieldset': {
                          borderColor: 'black'
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: 'blue'
                        }
                      }
                    }}
                    endAdornment={
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </form>
              {permissionMatrix && permissionMatrix.writeRights === true ? (
                <Button variant="contained" color="primary" onClick={handeRedirectAddContact} startIcon={<IconPlus />}>
                  Add
                </Button>
              ) : (
                <></>
              )}
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <DataGrid
              getRowId={(row) => row.id}
              rows={contacts}
              rowCount={rowCount}
              columns={columns}
              paginationMode="server"
              sortingMode="server"
              pageSizeOptions={[10]}
              paginationModel={paginationModel}
              onPaginationModelChange={setPaginationModel}
              components={{
                NoRowsOverlay: CustomNoRowsOverlay
              }}
              sortModel={sortModel}
              onSortModelChange={handleSortModelChange}
              columnVisibilityModel={{
                action: permissionMatrix?.writeRights
              }}
            />
          </Grid>
        </Grid>
      </MainCard>

      {/* Delete modal */}
      <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box sx={style}>
          <Typography sx={{ fontSize: '20px' }} id="modal-modal-title" variant="h6" component="h2">
            Delete Confirmation
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Are you sure you want to delete this record?
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'end' }}>
            <Button
              onClick={handleClose}
              variant="contained"
              color="error"
              sx={{ marginTop: '20px', marginRight: '20px', padding: '5px 30px' }}
            >
              Cancel
            </Button>
            <Button variant="contained" sx={{ marginTop: '20px', padding: '5px 30px' }} onClick={DeleteContact}>
              Confirm
            </Button>
          </Box>
        </Box>
      </Modal>
      <LoadingBackdrop open={isLoading} />
    </>
  );
}

export default Contact;
const sortInsuranceFiled = (filed) => {
  if (filed == 'policy') {
    return 'Policy';
  } else if (filed == 'company') {
    return 'Company';
  } else if (filed == 'type') {
    return 'Type';
  } else if (filed == 'policyNumber') {
    return 'PolicyNumber';
  }
  return '';
};
